module.exports = __webpack_public_path__ + "img/1696207736008-WhatsApp Image 2023-10-02 at 08.37.33.jpeg.ef14def8.webp";